"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _attachThemeAttrs = _interopRequireDefault(require("../../../styles/helpers/attachThemeAttrs"));

var _fontSizes = require("../../../styles/fontSizes");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    letter-spacing: 0.3px;\n    font-size: ", ";\n    color: ", ";\n    background-color: transparent;\n    text-decoration: none;\n    transition: color 0.1s linear;\n    cursor: pointer;\n    box-sizing: border-box;\n\n    :hover,\n    :focus {\n        text-decoration: underline;\n        color: ", ";\n    }\n\n    :active {\n        color: ", ";\n    }\n\n    :active,\n    :hover {\n        outline: 0;\n    }\n\n    :hover {\n        color: ", ";\n    }\n\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledAnchor = (0, _attachThemeAttrs["default"])(_styledComponents["default"].a)(_templateObject(), _fontSizes.FONT_SIZE_TEXT_MEDIUM, function (props) {
  return props.palette.text.label;
}, function (props) {
  return props.palette.brand.main;
}, function (props) {
  return props.palette.brand.main;
}, function (props) {
  return props.palette.brand.main;
}, function (props) {
  return props.disabled && "\n            color: ".concat(props.palette.text.disabled, ";\n            pointer-events: none;\n    ");
});
var _default = StyledAnchor;
exports["default"] = _default;